import React from 'react'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import DualRowColumn from 'ui/columns/DualRowColumn'

export default function DomainInfoColumns () {
  return (
    <>
      <Columns.Column name='domain' label='Domæne'>
        <DualRowColumn header={<Displays.Text name='domain' />}>
          <Displays.Text name='description' />
        </DualRowColumn>
      </Columns.Column>
      <Columns.Column name='domain_rating' label='DR' headerTitle='Domain Rating'>
        <DualRowColumn header={<Displays.Text name='domain_rating' label='DR' headerTitle='Domain Rating' />}>
          Ahrefs
        </DualRowColumn>
      </Columns.Column>
      <Columns.Column name='traffic' label='Trafik' headerTitle='Organic Traffic'>
        <DualRowColumn header={<Displays.Number name='traffic' label='Trafik' headerTitle='Organic Traffic' minDecimals={0} />}>
          Ahrefs
        </DualRowColumn>
      </Columns.Column>
      <Columns.Column name='backlinks' label='BL' headerTitle='Backlinks'>
        <DualRowColumn header={<Displays.Number name='backlinks' label='BL' headerTitle='Backlinks' minDecimals={0} />}>
          Ahrefs
        </DualRowColumn>
      </Columns.Column>
      <Columns.Column name='refdomains' label='Ref Dom' headerTitle='Refdomains'>
        <DualRowColumn header={<Displays.Number name='refdomains' label='Ref Dom' headerTitle='Refdomains' minDecimals={0} />}>
          Ahrefs
        </DualRowColumn>
      </Columns.Column>
    </>
  )
}
